import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { DivorceAccountGate } from '@/components/divorce/DivorceAccountGate';
import { SEO } from '@/components';
import { track } from '@/lib/analytics';

function DivorceClaimPage() {
  const { divorceToken } = Route.useSearch();
  const navigate = useNavigate();

  useEffect(() => {
    track('Divorce Claim Screen');
  }, []);

  if (!divorceToken) {
    return (
      <main className='flex min-h-screen items-center justify-center bg-gray-50 px-4'>
        <div className='w-full max-w-lg rounded-2xl border border-gray-200 bg-white p-8 text-center'>
          <h1 className='text-2xl font-bold text-gray-900'>This link is incomplete</h1>
          <p className='mt-3 text-gray-600'>
            Open the complete link from your Harbor email, or return to Harbor Divorce.
          </p>
          <Link to='/divorce' className='mt-6 inline-block font-semibold text-primary'>
            Harbor Divorce
          </Link>
        </div>
      </main>
    );
  }

  return (
    <>
      <SEO
        title='Save your divorce application | Harbor'
        description='Sign in to save and resume your Harbor Divorce application.'
        path='/claim'
        noindex
      />
      <main className='flex min-h-screen items-center justify-center bg-gray-50 px-4'>
        <div className='w-full max-w-lg rounded-2xl border border-gray-200 bg-white p-8'>
          <h1 className='text-2xl font-bold text-gray-900'>Save your application</h1>
          <p className='mt-2 text-gray-600'>
            Verify your Harbor account to resume this application on any device.
          </p>
          <DivorceAccountGate
            claimToken={divorceToken}
            ready={false}
            onReady={() => {
              void navigate({
                to: '/divorce/interview',
                search: {
                  claimToken: divorceToken,
                  state: undefined,
                  planToken: undefined,
                  fit: undefined,
                  purchase: undefined,
                },
                replace: true,
              });
            }}
          />
        </div>
      </main>
    </>
  );
}

export const Route = createFileRoute('/claim')({
  validateSearch: (search: Record<string, unknown>) => ({
    divorceToken:
      typeof search.divorceToken === 'string' ? search.divorceToken : undefined,
  }),
  component: DivorceClaimPage,
});
